import React, { Component } from 'react'
import { Card, Button, Form, Row, Collapse } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaMinus } from 'react-icons/fa';
import { isNullOrUndefined } from 'util';
import { connect } from 'react-redux';
import { pollOperations } from './state';
import { bindActionCreators } from 'redux';
import { MODE_EDIT, SUCCESS, DATE_TIME_FORMAT, NOTIF_SUCCESS, NOTIF_ERROR, EMPTY_STRING, CHOICE_ID, MAXNUMBER_OF_CHOICES, ADMIN, CHOICES, NO, SECONDARY, YES,
    DANGER } from '../../../utils/constants';
import { SideNotification, isStringEmptyOrNull } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, CHOICE_EMPTY, DELETE_POLLCHOICE, DELETE_MESSAGE, DELETE_POLLSELECTION } from '../../../utils/messages';
import moment from 'moment';
import ConfirmationModal from '../../components/ConfirmationModal';
import debounce from 'lodash.debounce';

class PollSelection extends Component {

    constructor(props) {
        super(props)
        this.state = {
            currentChoiceList: [],
            activeSelection: null,
            activeChoice: null,
            selectionList: [],
            choiceList: [],
            pollDetails: props.pollDetails,
            emptyFlag: false,
            currentSelection: props.selections,
            imageFile: null,
            mode: props.mode,
            donePoll: false,
            activeChoiceId: 0,
            activeSelectionId: 0,
            showDeleteChoiceModal: false,
            showDeleteSelectionModal: false,
            showCollapse: true
        }
        this.saveChoice = debounce(this.saveChoice.bind(this), 500);
        this.deleteChoice = debounce(this.deleteChoice.bind(this), 500);
        this.deleteSelection = debounce(this.deleteSelection.bind(this), 500); 

    }

    componentWillReceiveProps(newProps) {
        this.setState({
            selectionList: newProps.selections,
            pollDetails: newProps.pollDetails,
            currentSelection: newProps.selections,
            mode: newProps.mode
        })
    }

    componentDidMount() {

        let pollDetails = this.state.pollDetails

        let now = moment().format(DATE_TIME_FORMAT)
        if (moment(now).isAfter(pollDetails.pollEndDate)) {
            this.setState({
                donePoll: true
            })
        }
    }


    toggle = () => {
        this.setState({
            showCollapse: !this.state.showCollapse
        })
    }



    addChoice = () => {
        let tempSelectionList = this.state.currentSelection
        let choiceList = [...tempSelectionList.choiceList, { choiceLabel: EMPTY_STRING , choiceId: CHOICE_ID }]
        Object.assign(tempSelectionList, { choiceList });
        this.setState({
            selectionList: tempSelectionList,
            activeChoice: choiceList.length - 1
        })
    }

    editChoice = (choiceIdx) => {
        this.setState({
            activeChoice: choiceIdx
        })
    }

    saveChoice = (choice, choiceIdx, pollSelectionId, choiceId) => {

        let pollId = this.state.pollDetails.pollId

        let paramsAdd = {
            choiceLabel: choice.choiceLabel,
            selectionId: pollSelectionId
        }

        let paramsUpdate = {
            choiceLabel: choice.choiceLabel,
            selectionId: pollSelectionId,
            choiceId: choiceId
        }


        let tempSelectionList = this.state.currentSelection
        if (CHOICE_ID < choiceId) {
            tempSelectionList.choiceList[choiceIdx] = { choiceLabel: choice.choiceLabel, choiceId: choiceId }
        }
        else {
            tempSelectionList.choiceList[choiceIdx] = { choiceLabel: choice.choiceLabel, choiceId: 0, emptyFlag: false }
        }

        if (CHOICE_ID === choiceId) {
            this.props.insertPollSelectionChoice(paramsAdd, pollId, this.state.imageFile)
                .then((result) => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.setState({
                            selectionList: tempSelectionList,
                            activeSelection: null,
                            activeChoice: null
                        })
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
        else {
            this.props.updatePollSelectionChoice(paramsUpdate, pollId, this.state.imageFile)
                .then((result) => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.setState({
                            selectionList: tempSelectionList,
                            activeSelection: null,
                            activeChoice: null
                        })
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }

    deleteChoiceToggle = (id) => {
        this.setState({
            activeChoiceId: id,
            showDeleteChoiceModal: !this.state.showDeleteChoiceModal
        })
    }

    deleteChoice = () => {
        let pollId = this.state.pollDetails.pollId
        this.props.deletePollSelectionChoice(pollId, this.state.activeChoiceId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);

                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.deleteChoiceToggle(this.state.activeChoiceId);
            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    deleteSelectionToggle = (id) => {
        this.setState({
            activeSelectionId: id,
            showDeleteSelectionModal: !this.state.showDeleteSelectionModal
        })
    }

    deleteSelection = () => {
        let pollId = this.state.pollDetails.pollId
        this.props.deletePollSelection(pollId, this.state.activeSelectionId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }

                this.deleteSelectionToggle(this.state.activeSelectionId);

            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    handleInputChange = (event, i) => {

        let tempSelection = this.state.currentSelection
        let choiceLabel = event.target.value
        let choiceId = tempSelection.choiceList[i].choiceId


        if (CHOICE_ID < choiceId) {
            let currentChoice = tempSelection.choiceList[i] = { choiceLabel: choiceLabel, choiceId: choiceId }
            tempSelection.choiceList[i] = currentChoice
        }
        else {
            let currentChoice = tempSelection.choiceList[i] = { choiceLabel: choiceLabel, choiceId: CHOICE_ID }
            tempSelection.choiceList[i] = currentChoice
        }

        if (isStringEmptyOrNull(choiceLabel)) {
            if (CHOICE_ID < choiceId) {
                let choiceList = tempSelection.choiceList[i] = { choiceLabel: choiceLabel, choiceId: choiceId, emptyFlag: true }
                tempSelection.choiceList[i] = choiceList
            }
            else {
                let choiceList = tempSelection.choiceList[i] = { choiceLabel: choiceLabel, emptyFlag: true }
                tempSelection.choiceList[i] = choiceList
            }
        }

        this.setState({
            selectionList: tempSelection
        })
    }


    render() {
        let selection = this.state.currentSelection
        let pollDetails = this.state.pollDetails
        let now = moment().format(DATE_TIME_FORMAT)
        let user = this.props.isAuthenticated
        let donePoll = false
        let onGoingPoll = false
        if (moment(now).isAfter(pollDetails.pollEndDate)) {
            donePoll = true
        }
        else if (moment(now).isBetween(pollDetails.pollStartDate, pollDetails.pollEndDate) && ADMIN === user.credentials.accessRights) {
            onGoingPoll = true
        }

        return (
            <div>
                <Card className="card-collapse">
                    <Card.Header className="text-white" style={{ backgroundColor: 'var(--primaryColor)' }}>{selection.selectionTitle}{this.state.showCollapse ? <FaMinus className="toggle-button" onClick={() => this.toggle()} /> : <FaPlus className="toggle-button" onClick={() => this.toggle()} />}</Card.Header>
                    <Collapse in={this.state.showCollapse}>
                        <Card.Body>
                            <span style={{ fontSize: '14px' }}>{MAXNUMBER_OF_CHOICES}</span> <br />
                            <b style={{ marginLeft: '30px' }}>{selection.numChoices}</b> <br />
                            <span style={{ marginTop: '30px' }}>{CHOICES}</span><br />
                            <Button variant="light" style={{ borderColor: '#000000', visibility: onGoingPoll && 'hidden' }} disabled={!isNullOrUndefined(this.state.activeChoice) || MODE_EDIT !== this.state.mode || onGoingPoll} onClick={() => this.addChoice()}><FaPlus /> Add</Button>

                            {!isNullOrUndefined(selection.choiceList) && selection.choiceList.map((data, i) => {
                                let condition = (!isNullOrUndefined(this.state.activeChoice) && i !== this.state.activeChoice) || (MODE_EDIT !== this.state.mode || onGoingPoll)
                                return (
                                    <div key={i} style={{ marginTop: '10px' }}>
                                        <Row key={i} style={{ marginLeft: '0px' }}>
                                            <Form.Control onChange={(event) => this.handleInputChange(event, i)} maxLength="255" value={data.choiceLabel} data-item={i} name="choiceLabel" disabled={this.state.activeChoice !== i} style={{ width: '30%' }} placeholder={"Enter choice"}></Form.Control>
                                            {this.state.activeChoice === i ?

                                                <Button onClick={() => this.saveChoice(data, i, selection.selectionId, data.choiceId)} variant="light" disabled={data.emptyFlag || '' === data.choiceLabel || donePoll} className="button-selection" style={{ visibility: onGoingPoll && 'hidden' }}>
                                                    <FaCheck />
                                                </Button>
                                                :
                                                <div>
                                                    <Button onClick={() => this.editChoice(i)} disabled={condition} variant="light" className="button-selection" style={{ visibility: onGoingPoll && 'hidden' }}>
                                                        <FaEdit />
                                                    </Button>
                                                    <Button onClick={() => this.deleteChoiceToggle(data.choiceId)} disabled={condition} variant="light" className="button-selection"style={{ visibility: onGoingPoll && 'hidden' }}>
                                                        <FaTrash />
                                                    </Button>
                                                </div>
                                            }
                                        </Row>
                                        {(data.emptyFlag) &&
                                            (<p className="choice-error">{CHOICE_EMPTY}</p>)}
                                    </div>
                                )
                            })}
                        </Card.Body>
                    </Collapse>
                    <Collapse in={this.state.showCollapse}>
                        <Card.Footer style={{ visibility: onGoingPoll && 'hidden' }}>
                            <div style={{ float: 'right' }}>
                                <Button disabled={MODE_EDIT !== this.state.mode || onGoingPoll} onClick={() => this.deleteSelectionToggle(selection.selectionId)} variant="light" style={{ borderColor: '#000000', marginRight: '10px' }}>Delete</Button>
                            </div>
                        </Card.Footer>
                    </Collapse>
                </Card>
                <ConfirmationModal
                    show={this.state.showDeleteChoiceModal}
                    toggleModal={this.deleteChoiceToggle}
                    title={DELETE_POLLCHOICE}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.deleteChoiceToggle, variant: SECONDARY },
                        { label: YES, onClick: this.deleteChoice, variant: DANGER }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteSelectionModal}
                    toggleModal={this.deleteSelectionToggle}
                    title={DELETE_POLLSELECTION}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.deleteSelectionToggle, variant: SECONDARY },
                        { label: YES, onClick: this.deleteSelection, variant: DANGER }
                    ]}
                />
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        pollForm: state.polls.pollForm,
        selectInput: state.polls.selectInput,
        poll: state.polls.poll,
        isAuthenticated: state.auth,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        insertPollSelectionChoice: pollOperations.insertPollSelectionChoice,
        updatePollSelectionChoice: pollOperations.updatePollSelectionChoice,
        deletePollSelection: pollOperations.deletePollSelection,
        deletePollSelectionChoice: pollOperations.deletePollSelectionChoice
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(PollSelection);